import { render, staticRenderFns } from "./DragGroup.vue?vue&type=template&id=325dd276&"
import script from "./DragGroup.vue?vue&type=script&lang=js&"
export * from "./DragGroup.vue?vue&type=script&lang=js&"
import style0 from "./DragGroup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\customControl\\custom_stage_lv\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('325dd276')) {
      api.createRecord('325dd276', component.options)
    } else {
      api.reload('325dd276', component.options)
    }
    module.hot.accept("./DragGroup.vue?vue&type=template&id=325dd276&", function () {
      api.rerender('325dd276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/web/isv/kingdee/hr/adjustCandidates/components/DragGroup.vue"
export default component.exports